import React from "react";
import { usePhoneTheme } from "../../../ForBrands/useIsPhone";
import { HighlightTile } from "../coachPieces";
import { EMPTY_VALUE, initialsOf } from "../coachUtils";

// An insight card about one player (Figma "Highest CacheScore™", "Highest
// NILx"...). Without a player it keeps its place with the en dash and a
// plain note on what it waits for. On phones it is the row card with a 56px
// photo (2409:1264, 2411:2000).
const PlayerInsight = ({ eyebrow, player, title, value, chip, chipDot, emptyNote }) => {
  const layout = usePhoneTheme() ? "row" : "tile";
  return player ? (
    <HighlightTile layout={layout} eyebrow={eyebrow} avatar={player.avatar} initials={initialsOf(player)} title={title} value={value} chip={chip} chipDot={chipDot} />
  ) : (
    <HighlightTile layout={layout} eyebrow={eyebrow} title={EMPTY_VALUE} chip={emptyNote} />
  );
};

export default PlayerInsight;
